import { QuickQuoteResponseQuote } from 'lib/api/getQuickQuote';
import { Maybe, Undef } from 'types/UtilityTypes';

import { Suggestion } from '../types';
import {
  findCoachQuote,
  mapSuggestionFromQuote,
} from './mapSuggestionFromQuote';

export type ResolveLiveSuggestionArgs = {
  isQuickQuoteCoachEnabled: boolean;
  quotes: Undef<QuickQuoteResponseQuote[]>;
};

// Live Coach when the service flag is on and QQ v2 returned a kitcoach quote.
export function resolveLiveSuggestion({
  isQuickQuoteCoachEnabled,
  quotes,
}: ResolveLiveSuggestionArgs): Maybe<Suggestion> {
  if (!isQuickQuoteCoachEnabled) {
    return null;
  }

  return mapSuggestionFromQuote(findCoachQuote(quotes));
}

export function resolveSuggestion(
  args: ResolveLiveSuggestionArgs
): Maybe<Suggestion> {
  return resolveLiveSuggestion(args);
}

export function shouldShowCoach(
  isQuickQuoteCoachEnabled: boolean,
  quotes?: Undef<QuickQuoteResponseQuote[]>
): boolean {
  return (
    resolveLiveSuggestion({
      isQuickQuoteCoachEnabled,
      quotes,
    }) !== null
  );
}
